import type { PathObservation, SelectedNetworkPath } from '../streamRecovery/contracts';
import type { NetworkPathObserver } from '../streamRecovery/interfaces';

/** Connection-scoped path identity; a missing stat never invents a handoff. */
export class SelectedNetworkPathObserver implements NetworkPathObserver {
  private identity: string | undefined;
  private epoch = 0;

  observe(path: SelectedNetworkPath): PathObservation {
    if (path.selection !== 'selected' || !path.selectedPairId) {
      return { current: { epoch: this.epoch, selection: 'unavailable', reason: 'unavailable' }, changed: false };
    }
    const identity = JSON.stringify([path.transportId ?? null, path.selectedPairId]);
    const changed = this.identity !== undefined && identity !== this.identity;
    if (changed) this.epoch += 1;
    this.identity = identity;
    return { current: { epoch: this.epoch, selection: 'selected', reason: this.epoch === 0 ? 'initial' : 'selected-pair-change' }, changed };
  }

  reset(): void { this.identity = undefined; this.epoch = 0; }
}
